<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>资金管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="isShowDetails = false">费用统计</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!isShowDetails">
      <section class="searchBox">
        <span class="addStyle">
          <a-button
            style="margin-right: 20px"
            type="primary"
            icon="plus"
            @click="hideInAddInsurance = !hideInAddInsurance"
            >增加</a-button
          >
          <a-button v-show="!showIsSearch" @click="showIsSearch = true"
            >显示更多</a-button
          >
          <a-button v-show="showIsSearch" @click="showIsSearch = false"
            >隐藏更多</a-button
          >
        </span>
        <span>
          <label>结算类型：</label>
          <a-radio-group v-model="type">
            <a-radio :value="1">应收</a-radio>
            <a-radio :value="2">应付</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>状态：</label>
          <a-select style="width: 140px" v-model="status">
            <a-select-option :value="20">待项目负责人审核</a-select-option>
            <a-select-option :value="21">项目负责人驳回</a-select-option>
            <a-select-option :value="30">待财务审核</a-select-option>
            <a-select-option :value="31">财务驳回</a-select-option>
            <a-select-option :value="40">待打款/待收款</a-select-option>
            <a-select-option :value="41">出纳驳回</a-select-option>
            <!-- <a-select-option :value="42">已入账/已出账</a-select-option> -->
            <a-select-option :value="50">结算完成</a-select-option>
            <!-- <a-select-option :value="100">已作废</a-select-option> -->
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>费用类型：</label>
          <a-select style="width: 120px" v-model="finance_type_id">
            <a-select-option
              v-for="item in costTypeList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>项目：</label>
          <a-select
            v-model="project_id"
            style="min-width: 160px"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="element in proList"
              :key="element.id"
              :value="element.id"
              >{{ element.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <a-select
            defaultValue="1"
            style="width: 120px; margin-right: 6px"
            v-model="time_type"
          >
            <a-select-option :value="1">费用所属日期</a-select-option>
            <a-select-option :value="2">开票日期</a-select-option>
            <a-select-option :value="3">入账日期</a-select-option>
            <a-select-option :value="4">出账日期</a-select-option>
          </a-select>
          <a-range-picker
            v-model="date"
            @change="changeDate"
            style="width: 200px"
            :placeholder="['开始时间', '结束时间']"
          />
        </span>
        <span>
          <a-button @click="onReset" style="margin-right: 10px">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
            </tr>
            <!-- <tr v-show="data.length > 0">
              <td>合计</td>

              <td>{{ "应收：" + Number(count_data.total_receive) + "元" }}</td>
              <td>{{ count_data.total_receive_rate }}</td>
              <td>{{ "应付：" + Number(count_data.total_pay) + "元" }}</td>
              <td>{{ count_data.total_pay_rate }}</td>
            </tr> -->
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>
                <p v-if="item.type == 1">应收</p>
                <p v-else-if="item.type == 2">应付</p>
                <p v-else>未知</p>
              </td>
              <td>{{ item.pname + "-" + item.name }}</td>
              <td>{{ item.total_amount }}</td>
              <td>{{ item.rate }}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 详情 -->
    <advanceDetails v-show="isShowDetails" :detailsVal="detailsVal" />
    <!-- 详情 end -->
    <!-- 审核 -->
    <advanceAudit />
    <!-- 审核 end -->
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import advanceDetails from "@/components/money/advanceDetails";
import advanceAudit from "@/components/money/advanceAudit";
export default {
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      totalPage: Number,
      thList: ["项目", "结算类型", "费用类型", "金额", "占比"],
      proList: [],
      project_id: "",
      isShowDetails: false,
      detailsVal: {},
      status: "",
      query_field: "",
      month: "",
      monthVal: null,
      count_data: "",
      type: "",
      finance_type_id: "",
      costTypeList: [],
      time_type: 1,
      date: null,
      start_date: "",
      end_date: "",
      showIsSearch: false
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    advanceDetails,
    advanceAudit
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目
    this.getType();
  },
  methods: {
    selectMonth(date, dateString) {
      this.month = dateString;
    },
    changeDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
      // console.log(dateString);
    },
    getType() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Finance_type/getTwoLeave";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.costTypeList = res.data.data;
          // console.log(this.costTypeList);
        }
      });
    },
    auditManager() {},
    detailsPage(val) {
      this.isShowDetails = true;
      this.detailsVal = val;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 100000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          }
        });
    },
    onChange(pageNumber) {
      // console.log("Page: ", pageNumber);
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url + this.httpsBasic.finance + "Finance/countList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          project_id: this.project_id,
          finance_type_id: this.finance_type_id,
          time_type: this.time_type,
          start_date: this.start_date,
          end_date: this.end_date,
          type: this.type,
          status: this.status,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            this.count_data = res.data.data.count_data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    onReset() {
      this.project_id = "";
      this.query_field = "";
      this.status = "";
      this.start_date = "";
      this.end_date = "";
      this.monthVal = undefined;
      this.finance_type_id = "";
      this.time_type = 1;
      this.type = "";
      this.page = 1;
      this.getData();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    padding: 14px 2%;
    display: block;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
